import { compose } from 'recompose';

import { withTranslation } from 'react-i18next';
import DescriptionChannel from './descriptionChannel';

const enhance = compose(
  withTranslation(['common', 'chat']),
);
export default enhance(DescriptionChannel);
